// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderDetailsActionButtonsStyles } from "@hardwoods/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import List from "@hardwoods/XDL/Icons/List";
import Print from "@hardwoods/XDL/Icons/Print";
import { iconButtonCommonStyles } from "@hardwoods/XDL/Utilities/iconButtonCommonStyles";
import { mergeWithCss } from "@hardwoods/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.buttonsHiddenContainer = {
    ...mergeWithCss(savedOrderDetailsActionButtonsStyles.buttonsHiddenContainer, {
        css: css`
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
        `,
    }),
};

savedOrderDetailsActionButtonsStyles.printButton = {
    ...iconButtonCommonStyles(Print, {
        sizeVariant: "small",
        css: css`
            order: 4;
            display: none;
        `,
    }),
};

savedOrderDetailsActionButtonsStyles.addToListButton = {
    ...iconButtonCommonStyles(List, {
        sizeVariant: "small",
        css: css`
            order: 3;
            margin-left: 10px;
        `,
    }),
};

savedOrderDetailsActionButtonsStyles.deleteButton = {
    variant: "tertiary",
    css: css`
        margin-left: 10px;
        order: 2;
    `,
};

savedOrderDetailsActionButtonsStyles.printClickable = {
    css: css`
        &&& {
            display: none;
        }
    `,
};

savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    ...mergeWithCss(savedOrderDetailsActionButtonsStyles.placeOrderButton, {
        css: css`
            order: 1;
        `,
    }),
};
